import { Pipe, PipeTransform } from '@angular/core'

/**
 * receives a file size in bytes and transforms it to either KB or MB depending on the size
 *  - 0 Bytes < file size < 1024 Bytes => return Bytes
 *  - 1024 Bytes < file size < 1024 KB => return KB
 *  - file size > 1024 KB => return MB
 */
@Pipe({
  name: 'bytesToMB'
})
export class BytesToMBPipe implements PipeTransform {
  transform(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 KB'

    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))

    const sizeInUnits = bytes / Math.pow(k, i)

    // Adjust decimals for bytes
    const decimalPlaces = i === 0 ? 0 : decimals

    return `${sizeInUnits.toLocaleString('de-DE', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })} ${sizes[i]}`
  }
}
